﻿import Alpine from 'alpinejs';
import alpineFocus from '@alpinejs/focus'

import './autocomplete.js';
import './contenteditable.js';

Alpine.plugin(alpineFocus);
Alpine.start();
window.Alpine = Alpine;
